/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChangeOrderTemplatesControllerCreateMutationRequest, ChangeOrderTemplatesControllerCreateMutationResponse, ChangeOrderTemplatesControllerCreate400, ChangeOrderTemplatesControllerCreate401, ChangeOrderTemplatesControllerCreate403 } from "../../models/changeOrderTemplatesController/ChangeOrderTemplatesControllerCreate";

function getChangeOrderTemplatesControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/change-order-templates` as const }  
  return res
}

/**
 * @summary Link a project file as a change order template
 * {@link /api/v1/change-order-templates}
 */
export async function changeOrderTemplatesControllerCreate(data?: ChangeOrderTemplatesControllerCreateMutationRequest, config: Partial<RequestConfig<ChangeOrderTemplatesControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ChangeOrderTemplatesControllerCreateMutationResponse, ResponseErrorConfig<ChangeOrderTemplatesControllerCreate400 | ChangeOrderTemplatesControllerCreate401 | ChangeOrderTemplatesControllerCreate403>, ChangeOrderTemplatesControllerCreateMutationRequest>({ method : "POST", url : getChangeOrderTemplatesControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}